export default __webpack_public_path__ + "static/media/image-2.ff6b4324.png";